import { combineReducers } from 'redux';
import languageReducer from './languageReducer';
import authReducer from './authReducer';

export default combineReducers({
  i18n: languageReducer,
  auth: authReducer,
});
